export default {
	accounts_table_client_id: 'Client ID',
	accounts_table_id: 'Account',
	accounts_table_group: 'Group',
	accounts_table_type: 'Type',
	accounts_table_balance: 'Balance',
	accounts_table_sum_active_deals: 'Sum of Active Deals',
	accounts_table_bonus: 'Bonus',
	accounts_table_currency: 'Currency',
	accounts_table_created_at: 'Date Created',
	accounts_table_status: 'Status',
};